<h6 #headline>Produktdaten</h6>

@if (product().data; as data) {
  <ui-accordion class="accordion">
    <ng-template uiAccordionPanel headline="Halterbarkeit und Lagerung" icon="garage" iconStyle="light">
      <table class="accordion-table">
        <thead>
        <tr>
          <th colspan="2" class="single-table-header">Haltbarkeit und Lagerung</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>Restlaufzeit</td>
          <td>{{ data.durability }}</td>
        </tr>
        <tr>
          <td>Lagertemperatur (ungeöffnet)</td>
          <td>{{ data.durabilityStorage }}</td>
        </tr>
        </tbody>
      </table>
    </ng-template>

    <ng-template uiAccordionPanel headline="Inhaltsstoffe" icon="user-chef" iconStyle="light">
      <table class="accordion-table">
        <thead>
        <tr>
          <th colspan="2" class="single-table-header">Inhaltsstoffe</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>Zutatenliste</td>
          <td>{{ data.contentInformation?.content }}</td>
        </tr>
        @if (data.contentInformation?.alcoholPercent !== undefined) {
          <tr>
            <td>Alkoholgehalt</td>
            <td>{{ data.contentInformation.alcoholPercent | number }} %</td>
          </tr>
        }
        <tr>
          <td>Allergene</td>
          <td>
            @for (group of allergenGroups(); track group.status) {
              <div><strong>{{ allergenStatusLabelMap[group.status] }}:</strong> {{ group.allergens.join(', ') }}</div>
            } @empty {
              <div>Keine Angabe</div>
            }
          </td>
        </tr>
        </tbody>
      </table>
    </ng-template>

    <ng-template uiAccordionPanel headline="Verpackung" icon="boxes-packing" iconStyle="light">
      @if (data.packaging.length === 0) {
        <p>Keine Verpackungsinformationen vorhanden</p>
      } @else {
        @for (packagingItem of data.packaging; track packagingItem) {
          <table class="accordion-table">
            <thead>
            <tr>
              <th colspan="2" class="single-table-header">{{ packagingItem.name }}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Typ</td>
              <td>{{ packagingItem.type }}</td>
            </tr>
            <tr>
              <td>Material</td>
              <td>{{ packagingItem.material }}</td>
            </tr>
            <tr>
              <td>Recyclable</td>
              <td>
                <ui-icon faStyle="light" [faName]="packagingItem.recyclable? 'check' : 'times'"></ui-icon>
              </td>
            </tr>
            </tbody>
          </table>
        }
      }
    </ng-template>

    <ng-template uiAccordionPanel headline="Nährwertangaben" icon="table-list" iconStyle="light">
      @if (data.nutritionInformation.length > 0) {
        <table class="accordion-table">
          <thead>
          <tr>
            <th>Nährwert</th>
            <th>pro 100g</th>
            <th>1 Portion</th>
          </tr>
          </thead>
          <tbody>
            @for (item of data.nutritionInformation; track item) {
              <tr>
                <td>{{ nutritionInfoLabelMap[item.key] }}</td>
                <td>
                  @if (item.quantityPer100 !== undefined) {
                    {{ item.quantityPer100Operator }} {{ item.quantityPer100 | number }} {{ item.quantityPer100Unit }}
                  }
                </td>
                <td>
                  @if (item.quantity !== undefined) {
                    {{ item.quantityOperator }} {{ item.quantity | number }} {{ item.quantityUnit }}
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <p>Keine Nährwertangaben vorhanden</p>
      }
    </ng-template>

    <ng-template uiAccordionPanel headline="Maße und Gewicht" icon="weight-scale" iconStyle="light">
      @if (data.measuresAndWeight.length === 0) {
        <p>Keine Maß und Gewichtsangaben vorhanden</p>
      } @else {
        @for (measure of data.measuresAndWeight; track measure) {
          <table class="accordion-table measures-table">
            <thead>
            <tr>
              <th colspan="2" class="single-table-header">
                {{ measuresLabelMap[measure.subject] }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Länge</td>
              <td>{{ measure.length | number }} {{ measure.unit }}</td>
            </tr>
            <tr>
              <td>Breite</td>
              <td>{{ measure.width | number }} {{ measure.unit }}</td>
            </tr>
            <tr>
              <td>Höhe</td>
              <td>{{ measure.height | number }} {{ measure.unit }}</td>
            </tr>
            <tr>
              <td>Nettogewicht</td>
              <td>
                @if (measure.netWeight !== undefined) {
                  {{ measure.netWeight | number }} {{ measure.weightUnit }}
                }
              </td>
            </tr>
            <tr>
              <td>Bruttogewicht</td>
              <td>
                @if (measure.grossWeight !== undefined) {
                  {{ measure.grossWeight | number }} {{ measure.weightUnit }}
                }
              </td>
            </tr>
            </tbody>
          </table>
        }
      }
    </ng-template>
  </ui-accordion>

  @if (data.LMiVDocumentLink) {
    <ui-button
      class="download-button"
      buttonStyle="outlined"
      icon="file-pdf"
      iconStyle="light"
      (clicked)="openDocument(data.LMiVDocumentLink)"
    >
      LMIV Produktdatenblatt herunterladen
    </ui-button>
  }
  @if (data.securityDataSheetDocumentLink) {
    <ui-button
      class="download-button"
      buttonStyle="outlined"
      icon="file-pdf"
      iconStyle="light"
      (clicked)="openDocument(data.securityDataSheetDocumentLink)"
    >
      Sicherheitsdatenblatt herunterladen
    </ui-button>
  }
}

<div>
  <p class="disclaimer">
    Bei allen Angaben zum Produkt handelt es sich um Informationen, die Lekkerland von seinen Lieferanten erhalten hat.
    Diese Informationen werden von Lekkerland nicht eigenständig auf Vollständigkeit oder Richtigkeit überprüft. Die
    Angaben stellen insbesondere keine Beschaffenheitsvereinbarung oder Garantie dar. Dies gilt insbesondere für
    Zutaten, Allergene, Zusatzstoffe und Nährwertangaben. Verbindliche Angaben erhalten Sie vom Hersteller.
  </p>
</div>
